import { RightOutlined } from '@ant-design/icons';
import { Descriptions, Image, Row } from 'antd';
import { Link } from 'react-router-dom';

interface ICard {
  id?: string;
  UPC?: string;
  desUPC?: string;
  nameCenter?: string;
  desCenter?: string;
  amount?: string;
  amountNumber?: string;
  url?: any;
  image?: string;
  button?: string;
  isOrder?: boolean;
  productName?: string;
  orderNumber?: string;
  orderDate?: string;
}

const CardItem = (props: ICard) => {
  return (
    <>
      <div style={{ padding: '1rem' }}>
        <Row className="card-item img-normal">
          <img
            width={80}
            height={80}
            src={props.image ? props.image : '/images/image.svg'}
          />
          {/* <Image preview={false} width={80} height={80} src="" fallback={!!props.image ? props.image : "/images/image.svg"} /> */}
          <Descriptions>
            <Descriptions.Item>{props.UPC}</Descriptions.Item>
            <Descriptions.Item>
              {!props.isOrder ? props.desUPC : props.productName}
            </Descriptions.Item>
          </Descriptions>
          <Descriptions>
            <Descriptions.Item>
              {!props.isOrder ? props.nameCenter : props.orderNumber}
            </Descriptions.Item>
            <Descriptions.Item>
              {!props.isOrder ? props.desCenter : props.orderDate}
            </Descriptions.Item>
          </Descriptions>
          <Descriptions>
            <Descriptions.Item>
              {props.amount}{' '}
              <span style={{ marginLeft: '30px' }}>{props.amountNumber}개</span>
            </Descriptions.Item>
          </Descriptions>
          <Link to={props.url}>
            <RightOutlined style={{ marginLeft: '1rem' }} />
          </Link>
        </Row>
      </div>
    </>
  );
};

export default CardItem;
